import { render, staticRenderFns } from "./NoDeclara.vue?vue&type=template&id=6ec9d7c0&"
import script from "./NoDeclara.vue?vue&type=script&lang=js&"
export * from "./NoDeclara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports